import React, { useEffect, useState } from 'react';
import { url } from '../../Values/constants';
import axiosHandler from '../../Services/axiosHandler';
import { connect, useDispatch } from 'react-redux';
import styles from '../../Components/PlanCard/PlanCardNew.module.css';
import CenteredPopUp from '../../Components/CenteredPopUp/CenteredPopUp';
import AutomaticBillPayementContent from '../AutomaticBillPayementContent/AutomaticBillPayementContent';
import AutomaticBillSetUpContent from '../AutomaticBillSetUpContent/AutomaticBillSetUpContent';
import GSTModal from '../GSTModal/GSTModal';
import { pushToGA } from '../../Services/users';
import { pgiAutoLogin, createOrder } from '../../Services/pgi';
import { fetchOrganizationData } from '../../Services/organizations';
import PlanCardNew from '../../Components/PlanCard/PlanCardNew';
import { readproPackagePurchaseViaPGI } from "../../Services/pgi";
interface MarketingBussinessPlansProps {
	user?: any;
	organizationData?: any;
}

const MarketingBussinessPlans: React.FC<MarketingBussinessPlansProps> = ({ user, organizationData }) => {
	const [whatsappPlansData, setWhatsappPlansData] = useState<any>();
	const [finalWhatsappPlansData, setFinalWhatsappPlansData] = useState<any>();
	const [rate, setRate] = useState<any>();
	const [freePack, setFreePack] = useState<any>();
	const [openTryAutoPayModal, setOpenTryAutoPayModal] = useState<boolean>(false);
	const [openSetUpAutoPayModal, setOpenSetUpAutoPayModal] = useState<boolean>(false);
	const [recr, setRecr] = useState<any>();
	const [openGstModal, setOpenGstModal] = useState<boolean>(false);
	const [isThisTrial, setIsThisTrial] = useState<boolean>(false);
	const [originalPrice, setOriginalPrice] = useState<any>();
	const [offerPrice, setOfferPrice] = useState<any>();
	const [packageId, setPackageId] = useState<any>();
	const [balance, setBalance] = useState<any>();
	const [val, setVal] = useState<any>();
	const [discountVal, setDiscountVal] = useState<any>();
	const [orgPassData, setOrgPassData] = useState<any>();
	const [gst, setGst] = useState<any>('');
	const [isRecurringPay, setIsRecurringPay] = useState<any>('N');
	const [token, setToken] = useState<any>();
    const [defaultPackage, setDefaultPackage] = useState<any>();
	const dispatcher = useDispatch();

	const readProductList = async () => {
		const apiUrl = url + '/pgi/readProductList';
		const payload = {
			// organization_id:organizationData.organization_id
		};
// console.log("payload",payload)
		try {
			const response = await axiosHandler.post(apiUrl, payload);
			const data = response.data;
			// console.log("data.data",data.data)
			setWhatsappPlansData(data.data);
			setFinalWhatsappPlansData(data.data);
			setRate(data.rate)
			setFreePack(data.FREE_PACK)
		} catch (error: any) {
			throw error;
		}
	};

	const fetchOrgPassDataData = async () => {
		const PassData = await fetchOrganizationData(organizationData.organization_id);
		// console.log("PassData",PassData)
		setOrgPassData(PassData);
	};

	useEffect(() => {
		if(organizationData){readProductList();}
	}, [organizationData,user]);
	
	useEffect(() => {
		fetchOrgPassDataData();
	}, [organizationData]);

	useEffect(() => {
		if (whatsappPlansData) {
			if(freePack){const filteredPlans = whatsappPlansData.filter(
				(plan: any) => plan.packageId !== freePack
			  );
			const minPackage = filteredPlans.reduce((prev: any, current: any) => {
				return parseFloat(prev.discountedValue || "0") <= parseFloat(current.discountedValue || "0")
					? prev
					: current;
			});
			setDefaultPackage(minPackage)
		}}
	}, [whatsappPlansData, orgPassData,freePack]);

	const onClickHandler = (originalPrice: any, offerPrice: any, packageId: any, validity: any, balance: any, isRec: any, gstNumber: any) => {
		// pushToGA('event_tracking', 'read pro', 'read pro', 'Recharge click', user);
		pushToGA(
			"event_tracking",
			"read pro",
			"read pro",
			`whatsapp freeTrialMarketingPage | cta :Recharge click`,
			user,
			// eventLabel ? eventLabel : ""
		)
		readproPackagePurchaseViaPGI(user.user_super_oid, packageId, dispatcher, false, isRec, gstNumber);
		document.body.classList.add('no-overflow');
	};

	const handleWhatsappPackage = (originalPrice: any, offerPrice: any, packageId: any, validity: any, balance: any, dis: any, isTrial: any) => {
		if (isTrial === true) {
			pushToGA(
				"event_tracking",
				"read pro",
				"read pro",
				`whatsapp freeTrialMarketingPage | cta :Start 30 day trial click`,
				user,
				// eventLabel ? eventLabel : ""
			)
			readproPackagePurchaseViaPGI(user.user_super_oid, packageId, dispatcher, false);
		} else {
			fetchOrgPassDataData();
			setPackageId(packageId);
			setOfferPrice(offerPrice);
			setOriginalPrice(originalPrice);
			setBalance(balance);
			setVal(validity);
			setDiscountVal(dis);
			setOpenTryAutoPayModal(true);
		}
	};

	return (
		<>
			<div className={styles.PlanCardSec}>
				<div className={styles.PlanCardLabel}>
					<div className={styles.PlanCardLabelTitle}>Plan Name</div>
					<div className={styles.PlanCardDetail}>
						Validity <div className={styles.PlanCardSubLabel}>(in Days)</div>
					</div>
					<div className={styles.PlanCardDetail}>
						WhatsApp <div className={styles.PlanCardSubLabel}>Messages(upto)</div>
					</div>
					<div className={styles.PlanCardDetail}>Credit Balance</div>
					<div className={styles.PlanCardDetail}></div>
				</div>
				{finalWhatsappPlansData?.slice(0, 4).map((plan: any, index: number) => {
					return (
						<>
						<PlanCardNew
							key={index}
							isTopup={plan.isTopup}
							oAmount={plan.originalValue}
							newAmount={plan.discountedValue}
							discount={plan.discountPercent}
							validity={plan.validity}
							balance={plan.balance}
							linkTo={null}
							ctaText="Buy"
							// onClick={() => setDataHandler(plan.originalValue, plan.discountedValue, plan.packageId, plan.validity, plan.balance, plan.discountPercent,plan.isTrial)}
							onClick={() => handleWhatsappPackage(plan.originalValue, plan.discountedValue, plan.packageId, plan.validity, plan.balance, plan.discountPercent,plan.isTrial)}
							isTrial={plan.isTrial}
							isRecommended={index===1?true:false}
							packageName={plan.packageName}
							noOfMsg={plan.noOfMsg}
						/>
						</>
					);
				})}
				<div className={styles.PlanDisc}>
					Only <span className={styles.Rupees}>&#8377;</span>{defaultPackage?.discountedValue}+GST per month after trial ends. cancel anytime, <span className={styles.Bold}>{rate} per WhatsApp message</span>
				</div>
			</div>
			
			{openTryAutoPayModal && (
				<CenteredPopUp
					setModal={setOpenTryAutoPayModal}
					children={
						<AutomaticBillPayementContent
							setOpenSetUpAutoPayModal={setOpenSetUpAutoPayModal}
							PayModal={setOpenGstModal}
							setRecr={setRecr}
							originalPrice={originalPrice}
							offerPrice={offerPrice}
							packageId={packageId}
							setOpenTryAutoPayModal={setOpenTryAutoPayModal}
						/>
					}
					modiferClass={styles.Tabp}
					closeIcon={true}
				/>
			)}
			{openSetUpAutoPayModal && (
				<CenteredPopUp
					setModal={setOpenSetUpAutoPayModal}
					children={
						<AutomaticBillSetUpContent
							setOpenSetUpAutoPayModal={setOpenSetUpAutoPayModal}
							setOpenRechargeProcessing={setOpenGstModal}
							originalPrice={originalPrice}
							offerPrice={offerPrice}
							packageId={packageId}
							balance={balance}
							val={val}
							discountVal={discountVal}
							organizationData={orgPassData}
                    		screen="WhatsappRechangePlan"
						/>
					}
					modiferClass={styles.Tabp}
					closeIcon={true}
				/>
			)}
			{openGstModal && (
				<CenteredPopUp
					setModal={setOpenGstModal}
					children={<GSTModal setGst={setGst} PayModal={(gstNumber: any) => onClickHandler(originalPrice, offerPrice, packageId, val, balance, recr, gstNumber)} />}
					modiferClass={styles.gstPopup}
					closeIcon={true}
				/>
			)}
		</>
	);
};

const mapStateToProps = (state: any) => {
	return {
		user: state.user.data,
		organizationData: state.organization.organizationData,
	};
};

export default connect(mapStateToProps)(MarketingBussinessPlans);
